export const TYPE_ITEM = {
  FOLDER: 'folder',
  COMPUTER: 'computer',
};
export const setNodeAttributes = (node, checkedComp) => {
  const checked = checkedComp.has(node.id);
  node.ident = node.id + node.name;
  if (node.type === TYPE_ITEM.FOLDER) {
    node.opened = true;
    node.open = false;
    node.title = node.name;
    node.isContainChildren = true;
    node.checked = checked;
    node.children.forEach((child) => setNodeAttributes(child, checkedComp));
  } else {
    node.opened = false;
    node.checked = checked;
    node.dropDisabled = true;
    node.title = node.nameUser;
    node.user = node.name;
  }
};

const getCompIdsInFolder = (node) => node.children.reduce((acc, item) => {
  if (item.type === TYPE_ITEM.COMPUTER) {
    acc.push(item);
  } else {
    acc.push(...getCompIdsInFolder(item));
  }
  return acc;
}, []);

export const findFolderAndGetCompIds = (tree, mapFolder) => {
  tree.forEach((node) => {
    if (node.type === TYPE_ITEM.FOLDER) {
      const computers = getCompIdsInFolder(node);
      if (!mapFolder[node.id]) mapFolder[node.id] = computers;
      if (node?.children) findFolderAndGetCompIds(node.children, mapFolder);
    }
  });
};
